exports.components = {
  "component---src-page-types-page-js": () => import("./../../../src/page-types/page.js" /* webpackChunkName: "component---src-page-types-page-js" */),
  "component---src-page-types-post-js": () => import("./../../../src/page-types/post.js" /* webpackChunkName: "component---src-page-types-post-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

